import * as Backbone from "backbone";
import template_SelPanMenuHeaderView from './SelPanMenuHeaderView.ejs';
import {invokeLastFunc} from 'util/FuncUtil';

export const SelPanMenuHeaderView = Backbone.View.extend({
	/**
	 *
	 * @param options
	 * @param {Backbone.View} options.selpan
	 * @param {{}} options.fav
	 * @param {function} options.isAnyActive defines active state
	 * @param {String} options.icon
	 * @param {String} options.label
	 * @param {String} options.hint set as title-tooltip
	 */
	initialize(options) {
		this.selpan = options.selpan;
		this.fav = options.fav;
		this.isAnyActive = options.isAnyActive;
		this.delayed = invokeLastFunc(this, ['refreshStatus'], 20);
		this.state = new Backbone.Model({
			icon: options.icon,
			label: options.label,
			hint: options.hint,
		});
		this.listenTo(this.state, 'change', this.render);
		this.listenTo(this.fav.filter, "update reset change", this.delayed.refreshStatus);
		this.listenTo(this.fav.orders, "update reset change", this.delayed.refreshStatus);
		this.listenTo(this.fav.custom, "update reset change", this.delayed.refreshStatus);
		this.render();
	},
	refreshStatus() {
		let status = typeof this.isAnyActive === 'function' && this.isAnyActive();
		this.$c.button.toggleClass('MenuAccent', !!status)
	},
	refresh$Cache() {
		this.$c = {
			button: this.$('.CollapsibleToggleRegion'),
		};
	},
	render() {
		this.$el.html(template_SelPanMenuHeaderView({d: this.state.attributes}));
		this.refresh$Cache();
	},
});